import React, { useContext } from 'react';
import { AuthContext } from '../App';
import Navbar from '../components/Navbar';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import axios from 'axios';

const TestAdminPage = () => {
  const { API, user } = useContext(AuthContext);

  const testGenerateDraw = async () => {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      console.log('Token:', token ? 'קיים' : 'לא קיים');
      console.log('User:', user);
      console.log('API:', API);
      
      const response = await axios.post(
        `${API}/tournaments/d769be26-dbe3-4a50-8310-6729009d4a1b/generate-draw`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      toast.success(`הצלחה! ${response.data.matches_count} משחקים`);
    } catch (error) {
      console.error('שגיאה:', error);
      toast.error(`שגיאה: ${error.response?.data?.detail || error.message}`);
    }
  };

  const testResetTournament = async () => {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const response = await axios.post(
        `${API}/admin/tournaments/d769be26-dbe3-4a50-8310-6729009d4a1b/reset`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      toast.success(`הצלחה! ${response.data.matches_deleted} משחקים נמחקו`);
    } catch (error) {
      console.error('שגיאה:', error);
      toast.error(`שגיאה: ${error.response?.data?.detail || error.message}`);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="max-w-4xl mx-auto p-8">
        <h1 className="text-4xl font-bold mb-8">🧪 בדיקת כפתורי אדמין</h1>
        
        <div className="bg-white p-6 rounded-lg shadow mb-8">
          <h2 className="text-2xl font-bold mb-4">מידע על המשתמש:</h2>
          <pre className="bg-gray-100 p-4 rounded text-sm overflow-auto">
            {JSON.stringify(user, null, 2)}
          </pre>
        </div>

        <div className="bg-white p-6 rounded-lg shadow mb-8">
          <h2 className="text-2xl font-bold mb-4">סטטוס:</h2>
          <p className="text-lg mb-2">מחובר: {user ? '✅ כן' : '❌ לא'}</p>
          <p className="text-lg mb-2">אדמין: {user?.is_admin ? '✅ כן' : '❌ לא'}</p>
          <p className="text-lg mb-2">API: {API}</p>
        </div>

        <div className="bg-white p-6 rounded-lg shadow space-y-4">
          <h2 className="text-2xl font-bold mb-4">כפתורי בדיקה:</h2>
          
          <Button
            onClick={testGenerateDraw}
            className="w-full bg-purple-600 hover:bg-purple-700 text-white text-lg py-6"
          >
            🎲 בדוק הגרלה
          </Button>

          <Button
            onClick={testResetTournament}
            className="w-full bg-red-600 hover:bg-red-700 text-white text-lg py-6"
          >
            🔄 בדוק איפוס
          </Button>

          <div className="mt-4 p-4 bg-yellow-50 border border-yellow-200 rounded">
            <p className="font-bold">הוראות:</p>
            <p>1. לחץ על כפתור</p>
            <p>2. בדוק בconsole (F12) אם יש שגיאות</p>
            <p>3. תראה הודעת הצלחה או שגיאה</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestAdminPage;
